export default "__VITE_ASSET__GxZVbdRS__"